import { Icon, ListItem, makeStyles, Text } from '@rneui/themed'
import { font } from 'app/theme'
import React from 'react'
import { StyleProp, View, ViewStyle } from 'react-native'

// FIXME: Animate Collapsible

/* The React Native Elements ListItem.Accordion component uses the `maxHeight` property, which
does not work with ScrollView. 

   See https://github.com/@rneui/themed/@rneui/themed/issues/3200

If that gets fixed, we can use it, otherwise we need to do our own animations. */

export interface Props {
  title: string
  value: string | number | undefined
  children: React.ReactNode
  expanded: boolean
  onPress(): void
  required?: boolean
  disabled?: boolean
  icon?: React.ReactElement<{}> | null
  containerStyle?: StyleProp<ViewStyle>
}

export function Collapsible({
  title,
  value,
  expanded,
  onPress,
  required,
  disabled,
  icon,
  children,
  containerStyle,
}: Props) {
  const styles = useStyles({ disabled, expanded })

  return (
    <>
      <ListItem
        disabled={disabled}
        onPress={onPress}
        containerStyle={containerStyle}
      >
        <ListItem.Content>
          <ListItem.Title style={styles.title}>{title}</ListItem.Title>
        </ListItem.Content>
        {value ? (
          <Text style={styles.value}>{value}</Text>
        ) : required ? (
          <Text style={styles.requiredPrompt}>Required</Text>
        ) : (
          <Text style={styles.blankValue}>Any</Text>
        )}
        {disabled && icon !== null ? (
          <View style={styles.icon} />
        ) : icon === undefined ? (
          <Icon
            color={styles.icon.color}
            style={styles.icon}
            name="menu-right"
            type="material-design"
          />
        ) : (
          icon
        )}
      </ListItem>
      {expanded ? <View>{children}</View> : null}
    </>
  )
}

export const useStyles = makeStyles(
  (theme, props: { disabled?: boolean; expanded?: boolean }) => ({
    title: {
      color: props.disabled ? theme.colors?.grey3 : theme.colors?.black,
      marginHorizontal: 0,
    },
    value: {
      fontSize: 17,
      color: theme.colors?.grey2,
    },
    blankValue: {
      fontSize: 17,
      color: theme.colors?.grey3,
    },
    requiredPrompt: {
      fontSize: 17,
      color: theme.colors?.grey3,
      fontFamily: font.italic,
    },
    icon: {
      width: 24,
      color: theme.colors?.grey4,
      transform: [{ rotate: props.expanded ? '90deg' : '0deg' }],
    },
  })
)
